module.exports = __webpack_public_path__ + "static/img/goods-400.5a5f9b2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/s28/pop/goods-400.png
// module id = 8p2Z
// module chunks = 2